import { MouseEvent } from 'react';
import { Avatar, ListItemAvatar, ListItemButton, ListItemText, Skeleton } from '@mui/material';

import { NotificationProps } from '@/features/notifications/types/NotificationProps';

const stopPropagationAndPreventDefault = (event: MouseEvent<HTMLAnchorElement>) => {
  event.stopPropagation();
  event.preventDefault();
};

export type NotificationsItemProps = {
  divider: boolean;
} & NotificationProps;

export const NotificationsItem = ({
  divider,
  isLoading,
  isUnread,
  markAsRead,
  href,
  target,
  Icon,
  title,
  description,
}: NotificationsItemProps) => (
  <ListItemButton
    divider={divider}
    selected={isLoading ? undefined : isUnread}
    href={isLoading ? undefined : href}
    target={isLoading ? undefined : target}
    onClick={isLoading ? stopPropagationAndPreventDefault : markAsRead}
  >
    <ListItemAvatar>
      <Avatar sx={{ bgcolor: 'transparent' }}>
        <Icon color="action" fontSize="large" />
      </Avatar>
    </ListItemAvatar>
    <ListItemText
      primary={isLoading ? <Skeleton /> : title}
      primaryTypographyProps={{ variant: 'subtitle2', component: 'div' }}
      secondary={isLoading ? <Skeleton /> : description}
      secondaryTypographyProps={{ variant: 'body2', component: 'div' }}
    />
  </ListItemButton>
);
